(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');

    // controller for agenda appointment info 
    module.controller('WarningModalController', ['$uibModalInstance', 'users', WarningModalControllerControllerFn]);

    function WarningModalControllerControllerFn($uibModalInstance, users) {
        var vm = this;

        // patient
        vm.users = null;

        activate();

        // cancel
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };


        // activation work
        function activate() {
            vm.users = users;
        } // activate

    }

})();